import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-inbox',
  imports: [CommonModule],
  template: `
    <svg
      width="24"
      height="24"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      [ngClass]="{ 'size-16': color === 'black' }"
    >
      <g clip-path="url(#clip0_482_4919)">
        <path
          d="M15.1481 17.5087H3.15196C2.79094 17.5087 2.43345 17.4376 2.09991 17.2994C1.76637 17.1613 1.46331 16.9588 1.20803 16.7035C0.952752 16.4482 0.750253 16.1451 0.612097 15.8116C0.47394 15.4781 0.402832 15.1206 0.402832 14.7596V8.76148C0.402832 8.56263 0.481824 8.37193 0.622432 8.23132C0.763039 8.09071 0.953744 8.01172 1.15259 8.01172C1.35144 8.01172 1.54215 8.09071 1.68275 8.23132C1.82336 8.37193 1.90235 8.56263 1.90235 8.76148V14.7596C1.89835 14.9262 1.92772 15.0919 1.98873 15.247C2.04973 15.4021 2.14114 15.5434 2.25758 15.6626C2.37402 15.7818 2.51313 15.8766 2.66672 15.9412C2.82032 16.0059 2.9853 16.0392 3.15196 16.0392H15.1481C15.4795 16.0392 15.7974 15.9075 16.0317 15.6732C16.2661 15.4388 16.3977 15.121 16.3977 14.7896V8.79147C16.3977 8.59262 16.4767 8.40192 16.6173 8.26131C16.7579 8.1207 16.9486 8.04171 17.1475 8.04171C17.3463 8.04171 17.537 8.1207 17.6777 8.26131C17.8183 8.40192 17.8973 8.59262 17.8973 8.79147V14.7896C17.8894 15.5135 17.5962 16.205 17.0815 16.7141C16.5668 17.2232 15.8721 17.5087 15.1481 17.5087Z"
          [ngClass]="{
            'fill-white': color === 'white',
            'fill-[#616161]': color === 'black'
          }"
        />
        <path
          d="M9.15007 12.7603C8.24294 12.7608 7.36655 12.4315 6.6842 11.8338C6.00186 11.2361 5.5601 10.4106 5.44125 9.51131H1.15262C1.01806 9.51231 0.885715 9.47709 0.769461 9.40932C0.653208 9.34156 0.557334 9.24375 0.491899 9.12617C0.426463 9.00859 0.393877 8.87557 0.397559 8.74106C0.401241 8.60655 0.441055 8.4755 0.512825 8.36168L4.24164 2.36359C4.39473 2.09583 4.6182 1.87509 4.88782 1.7253C5.15744 1.57551 5.46292 1.50239 5.77115 1.51387H12.529C12.8584 1.51477 13.1808 1.60921 13.4587 1.78619C13.7365 1.96316 13.9584 2.2154 14.0985 2.51355L17.7873 8.45165C17.8379 8.5626 17.8607 8.68422 17.8537 8.80596C17.8466 8.9277 17.81 9.04589 17.747 9.15028C17.684 9.25467 17.5964 9.34211 17.492 9.40502C17.3875 9.46794 17.2693 9.50442 17.1475 9.51131H12.8589C12.74 10.4106 12.2983 11.2361 11.6159 11.8338C10.9336 12.4315 10.0572 12.7608 9.15007 12.7603ZM2.50219 8.04178H6.15103C6.34987 8.04178 6.54058 8.12077 6.68119 8.26138C6.82179 8.40199 6.90079 8.59269 6.90079 8.79154V9.01147C6.90079 9.60802 7.13776 10.1801 7.55959 10.602C7.98141 11.0238 8.55352 11.2608 9.15007 11.2608C9.74662 11.2608 10.3187 11.0238 10.7406 10.602C11.1624 10.1801 11.3994 9.60802 11.3994 9.01147V8.79154C11.3994 8.59269 11.4783 8.40199 11.619 8.26138C11.7596 8.12077 11.9503 8.04178 12.1491 8.04178H15.7979L12.7989 3.18333C12.7189 3.04338 12.639 2.9834 12.539 2.9834H5.77115C5.72393 2.98457 5.67784 2.99811 5.63749 3.02267C5.59715 3.04723 5.56395 3.08194 5.54122 3.12335L2.50219 8.04178Z"
          [ngClass]="{
            'fill-white': color === 'white',
            'fill-[#616161]': color === 'black'
          }"
        />
      </g>
      <defs>
        <clipPath id="clip0_482_4919">
          <rect
            width="17.5"
            height="17.5"
            [ngClass]="{
              'fill-white': color === 'white',
              'fill-[#616161]': color === 'black'
            }"
            transform="translate(0.397308 0.760742)"
          />
        </clipPath>
      </defs>
    </svg>
  `
})
export class InboxComponent {
  @Input() color = 'white';
}
